import React, { useState, useEffect } from 'react';
import { View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { useComponentTKey, i18nNS } from '../../i18n';
import { saveApprover } from '../../store/actions/profile';
import PickerSelect from '../PickerSelect';
import BottomButton from '../BottomButton';

export default function ApprovalForm({ approvalList, approvalKey, UserProfileId }) {
  const { tKey } = useComponentTKey('MeScreen');
  const { t } = useTranslation(i18nNS.me);
  const [loading, setLoading] = useState(false);
  const [approval, setApproval] = useState(0);
  const dispatch = useDispatch();

  const onPressSubmit = () => {
    approvalKey !== approval && submmit();
  };

  useEffect(() => {
    setApproval(approvalKey);
  }, [approvalKey]);

  const submmit = () => {
    setLoading(true);
    (async () => {
      const data = { ApproverKey: approval, UserProfileId: UserProfileId };
      await dispatch(saveApprover(data));
      setLoading(false);
    })();
  };

  return (
    <View>
      <PickerSelect
        onValueChange={(value) => {
          setApproval(isNaN(value) ? null : value);
        }}
        value={approval}
        placeholder={{ label: t(tKey('Approver')) }}
        items={approvalList}
      />
      {approvalKey !== undefined && (
        <BottomButton onPress={onPressSubmit} label={t(tKey('UpdateApprover'))} loading={loading} />
      )}
    </View>
  );
}
